import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { your } from 'src/lib/flow/text';

const hoaTypePage: FlowPage = {
  slug: () => 'hoa-type',
  isEnabled: ({ answers }) => {
    return answers['home.hoa'] === 'yes';
  },
  title: ({ answers, inputContext: { channel } }) => {
    return `Does ${your(answers, channel)} home belong to any of these types of communities?`;
  },
  autoAdvance: () => true,
  questions: (): FlowQuestion[] => {
    return [
      {
        key: 'home.hoa_type',
        showNoneOfTheAbove: true,
        type: 'multi_select',
        options: [
          {
            label: 'Age restricted community',
            value: 'age_restricted_community',
          },
          {
            label: 'Gated community',
            value: 'gated_community',
          },
        ],
      },
    ];
  },
};

export default hoaTypePage;
